import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["template", "container"]
  static values = { wrapperSelector: { type: String, default: ".nested-fields" } }

  connect() {
    this.syncReportTypeOptions()
  }

  add() {
    const content = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, Date.now())
    this.containerTarget.insertAdjacentHTML("beforeend", content)
    this.syncReportTypeOptions()
  }

  remove(event) {
    const wrapper = event.target.closest(this.wrapperSelectorValue)
    if (!wrapper) return

    const destroyField = wrapper.querySelector("input[name*='_destroy']")
    if (destroyField) {
      destroyField.value = "1"
      wrapper.style.display = "none"
    } else {
      wrapper.remove()
    }
    this.syncReportTypeOptions()
  }

  syncReportTypes() {
    this.syncReportTypeOptions()
  }

  updateFilename(event) {
    const fileInput = event.target
    const wrapper = fileInput.closest(this.wrapperSelectorValue)
    if (!wrapper) return

    const filenameField = wrapper.querySelector("input[name*='original_filename']")
    if (filenameField && fileInput.files[0]) {
      filenameField.value = fileInput.files[0].name
    }
  }

  syncReportTypeOptions() {
    const selects = this.containerTarget.querySelectorAll("select[name*='report_type']")
    const visibleSelects = Array.from(selects).filter(select => {
      const wrapper = select.closest(this.wrapperSelectorValue)
      return wrapper && wrapper.style.display !== "none"
    })

    const selectedValues = visibleSelects
      .map(select => select.value)
      .filter(value => value !== "")

    visibleSelects.forEach(select => {
      Array.from(select.options).forEach(option => {
        if (option.value === "") return
        const isSelectedElsewhere = selectedValues.includes(option.value) && select.value !== option.value
        option.disabled = isSelectedElsewhere
      })
    })
  }
}
